// Local Storage
export const SEARCH_HISTORY_STORAGE_KEY = 'search-history';
export const SEARCH_HISTORY_SEPARATOR = ';';
export const SEARCH_HISTORY_LIMIT = 20;

// Display of history
export const HISTORY_MAX_LENGTH = 6;
export const HISTORY_IN_EMPTY_STATE_MAX_LENGTH = 4;
export const HISTORY_IN_QUERY_SUGGESTIONS_MAX_LENGTH = 2;
